import { Theme } from '@/components/theme-provider';

const API_BASE = '/api/v1';

/**
 * Fetches the user's theme preference from the server and returns it
 * This is used to sync the theme preference between the server and client
 */
export async function fetchUserThemePreference(): Promise<Theme | null> {
  try {
    const response = await fetch(`${API_BASE}/users/settings`, {
      credentials: 'include'
    });
    
    if (!response.ok) {
      throw new Error(`Failed to fetch theme preference: ${response.status}`);
    }
    
    const data = await response.json();
    return data.theme as Theme;
  } catch (error) {
    console.error('Error fetching theme preference:', error);
    return null;
  }
}
